<template>
  <div class="history">
    <div style="padding: 0px 20px;">
      <div class="search">
        <div class="search_box">
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[0].title}}</span>
            <el-select class="select" v-model="selectProjectValue" placeholder="请选择项目" @change="getSelectTeam(selectProjectValue )">
              <el-option v-for="item in search[0].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[1].title}}</span>
            <el-select class="select" v-model="selectTeamValue" placeholder="请选择群组" @change="getSelectWork(selectTeamValue )">
              <el-option v-for="item in search[1].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[2].title}}</span>
            <el-select class="select" v-model="selectWorkValue" placeholder="请选择小组" >
              <el-option v-for="item in search[2].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div class="search_options_box">
            <span style="width: auto;white-space: nowrap">灯杆编号</span>
            <input type="text" id="number" style="width: calc(100% - 72px);" placeholder="请输入灯杆编号" v-model="lamppostid" />
          </div>
          <div class="search_options_box" style="width: 30%">
            <span style="width: auto;white-space: nowrap">选择时间</span>
            <el-date-picker
              type="date"
              v-model="startDate"
              value-format="yyyy-MM-dd"
              placeholder="     请选择开始时间"
              id="start"
              style="margin-right: 5px">
            </el-date-picker>
            <span style="width: auto">~</span>
            <el-date-picker
              type="date"
              v-model="endDate"
              value-format="yyyy-MM-dd"
              placeholder="     请选择结束时间"
              id="end">
            </el-date-picker>
          </div>
          <div class="search_btn_box">
            <button :class='["search_btn","green","icon_btn","clearborder"]' @click="getCurrentPageData(),hahaall()">
              <span class="el-icon-search"></span>搜索
            </button>
          </div>
        </div>
      </div>

      <!--        表格-->
      <div class="table_content">
        <table>
          <thead>
            <tr>
              <th>日期</th>
              <th>位置</th>
              <th>灯杆编号</th>
              <th>气温（℃）</th>
              <th>湿度（RH）</th>
              <th>PM2.5（μg/m³）</th>
              <th>噪声（dB）</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in currentPageData" :key="index">
              <td>{{item.create_datetime}}</td>
              <td>{{item.site}}</td>
              <td>{{item.lamppost_id}}</td>
              <td>{{item.temperature}}</td>
              <td>{{item.humidity}}</td>
              <td>{{item.haze}}</td>
              <td>{{item.noise}}</td>
              <td class="table_btn_box">
                <button class="table_btn" style=" margin-right: 20px;" @click="twentyfourlightdata=!twentyfourlightdata">24小时走势图</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table_paging">
        <p>当前记录<span>{{(this.currentPage-1)*9+1}}</span>到<span>{{(this.currentPage-1)*9+this.currentPageData.length}}</span>条，共<span>{{totalCount}}</span>条记录
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
          <button
            @click="prevPage()" v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
          第<span>{{currentPage}}</span>/<span>{{totalPage}}</span>页
          <button
            @click="nextPage()" v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
        </p>
      </div>
    </div>

    <!--  24小时走势图-->
    <transition name="fade">
        <div class="mark" v-show="twentyfourlightdata">
        <div class="mark_close" @click="twentyfourlightdata=!twentyfourlightdata"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'700px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
<!--          <div class="h_light_right" :style="{top:'95px'}"></div>-->
          <div class="information_content issue_search_box model">
            <h1>
              24小时走势图
            </h1>
            <div style="width: 680px;height: 300px;padding-left: 15px;padding-top: 20px;" id="user">
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  //引入echarts
  let echarts = require('echarts/lib/echarts');
  // 引入柱状图组件
  require('echarts/lib/chart/bar');
  require('echarts/lib/chart/line');
  require('echarts/lib/chart/scatter');
  require('echarts/lib/chart/effectScatter');
  // 引入提示框和title组件
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/title');
  require('echarts/lib/component/legend');
  require('echarts/lib/component/geo');




export default {
  name: "history",
  data() {
    return {
      search: [
        {
          title: '选择项目',
          options: [],
        }, {
          title: '选择群组',
          options: [],
        }, {
          title: '选择小组',
          options: [],
        },
      ],
      user_data_day: [
        {name: "0时", value: -1},
        //{name: "1时", value: 315},
        {name: "2时", value: -2},
        //{name: "3时", value: 235},
        {name: "4时", value: 0},
        //{name: "5时", value: 131},
        {name: "6时", value: 2},
        //{name: "7时", value: 321},
        {name: "8时", value: 4},
        //{name: "9时", value: 315},
        {name: "10时", value: 8},
        //{name: "11时", value: 316},
        {name: "12时", value: 10},
        //{name: "13时", value: 325},
        {name: "14时", value: 9},
        //{name: "15时", value: 395},
        {name: "16时", value: 5},
        //{name: "17时", value: 312},
        {name: "18时", value: 3},
        //{name: "19时", value: 321},
        {name: "20时", value: 2},
        //{name: "21时", value: 191},
        {name: "22时", value: 0},
        //{name: "23时", value: 321},
      ],
      twentyfourlightdata:false,
      projectList:[],
      teamList:[],
      workList:[],
      lamppostid:'',
      startDate:'',
      endDate:'',
      selectProjectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
      selectTeamValue:'',
      selectWorkValue:'',
      //分页
      totalCount: 0, // 统共页数，默认为1
      totalPage: 1, // 统共页数，默认为1
      currentPage: 1, //当前页数 ，默认为1
      pageSize: 9, // 每页显示数量
      currentPageData: [] //当前页显示内容
    };
  },

  mounted() {
    this.getProjectList();
    this.getCurrentPageData();
    this.user_day();
  },
  methods: {
    InitLeftMenu:function () {
      this.$emit('getMessage', '1','1');
    },


    user_day: function () {
      // if(this.income_data_quarter!==""){
      //   // this.$axios.get("",{
      //   //
      //   // }).then((res)=>{
      //   //    this.income_data_quarter = res
      //   // })
      // }
      let date = [];
      let data = [];
      for (let i = 0; i < this.user_data_day.length; i++) {
        date.push(this.user_data_day[i].name);
        data.push(this.user_data_day[i].value);
      }
      let myChart1 = echarts.init(document.getElementById('user'));
      myChart1.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow',        // 默认为直线，可选为：'line' | 'shadow'
            shadowStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(1,200,179,0)' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(1,200,179,1)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              },
              opacity: 0.35
            }
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          top: "20%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: [{
          type: "category",
          data: date,
          axisTick: {
            alignWithLabel: true
          },
          nameTextStyle: {
            color: "#ffffff"
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#244465",

            }
          },
          offset: 5,
          axisLabel: {
            textStyle: {
              color: "#ffffff"
            }
          }
        }],
        yAxis: [{
          name: "温度",
          type: "value",
          nameTextStyle: {
            color: "#ffffff",
            fontSize: 14,
            align: "left",
          },
          axisLabel: {
            show: false,
            textStyle: {
              color: "#ffffff"
            },
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#244465",
            }
          }
        }],
        series: [{
          type: "line",
          smooth: true,
          symbolSize: 12,
          symbol: 'circle',
          itemStyle: {
            normal: {
              opacity: 1,
              color: "#01c8b3",
              shadowColor: 'rgba(0,156,140,0.35)',
              shadowBlur: 5,
              shadowOffsetY: 5
            },
          },
          lineStyle: {
            width: 4,
            color: '#01c8b3',
            shadowColor: 'rgba(72,216,191, 0.3)',
            shadowBlur: 5,
            shadowOffsetY: 5
          },
          markPoint: {
            symbol: 'circle',
            symbolSize: 20,
            data: [
              {type: 'max', name: '最大值'},
              {type: 'min', name: '最小值'}
            ],
            label: {
              show: true,
              position: "top",
              color: '#ffffff'
            }
          },
          markLine: {
            symbol: 'none',
            label: {
              position: "left",
              formatter: '{c}',
              color:"#ffffff",
            },
            data: [
              {
                name: "最大值",
                type: 'max',//res.targetTwo,
                lineStyle: {
                  color: "#244465"
                },
              }, {
                name: "最小值",
                type: 'min',//res.targetTwo,
                lineStyle: {
                  color: "#244465"
                },
              }
            ]
          },
          data: data
        }]
      });
      window.onresize = function () {
        myChart1.resize();
      };
    },




    // hahaall:function(){
    //   alert(this.selectProjectValue)
    //   alert(this.selectTeamValue)
    //   alert(this.selectWorkValue)
    //   alert(this.lamppostid)
    //   alert(this.startDate)
    //   alert(this.endDate)
    // },
    // 设置当前页面数据，对数组操作的截取规则为[0~9],[10~20]...,
    // 当currentPage为1时，我们显示(0*pageSize+1)-1*pageSize，当currentPage为2时，我们显示(1*pageSize+1)-2*pageSize...
    getCurrentPageData() {
     fetch("/api/v1/sensor/record/list", {
        method: 'post',
        body: JSON.stringify({
          project_id:this.selectProjectValue,
          groups_id:this.selectTeamValue,
          controller_id:this.selectWorkValue,
          Lamppost_id :this.lamppostid,
          start_date:this.startDate,
          end_date:this.endDate,
          "page_start":this.currentPage-1,
          "page_size":this.pageSize,
        })
      }).then(result => {
          return result.json();//解析流
        }).then(data => {
          this.currentPageData = data.data;
          this.totalCount = data.total_count;
          this.totalPage = Math.ceil(this.totalCount / this.pageSize);
          this.selectProjectValue='';
          this.selectTeamValue='';
          this.selectWorkValue='';
        }).catch((error) => {
          console.log(error);
        });
    },

    //获取小组列表
    getSelectWork:function(id){
      fetch("/api/v1/controller/list", {
        method: 'post',
        body: JSON.stringify({
          "groups_id":id,
          "page_size":10,
          "page_start":0,
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        //.then(data => console.log(data))
        .then(data => {
          if (data.code == "200") {
            this.message = "小组数据获取成功";
            this.search[2].options=[];
            this.workList = data.data;
            let options = this.search[2].options;
            for (let i=0;i<this.workList.length;i++){
              let projectObj = {};
              projectObj.label = this.workList[i].name;
              projectObj.value = this.workList[i].id;
              options.push(projectObj);
            };
          } else {
            this.message = "数据更新异常，请重试";
          }
        })
        .catch((error) => {
          this.message = "网络异常，请重试";
          this.msg_show = !this.msg_show;
        });
    },



    //获取群组列表
    getSelectTeam:function(id){
      fetch("/api/v1/groups/list", {
        method: 'post',
        body: JSON.stringify({
          "project_id":id,
          "page_size":10,
          "page_start":0,
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        //.then(data => console.log(data))
        .then(data => {
          if (data.code == "200") {
            this.message = "群组数据获取成功";
            this.search[1].options=[];
            this.search[2].options=[];
            this.teamList = data.data;
            let options = this.search[1].options;
            for (let i=0;i<this.teamList.length;i++){
              let projectObj = {};
              projectObj.label = this.teamList[i].name;
              projectObj.value = this.teamList[i].id;
              options.push(projectObj);
            };
          } else {
            this.message = "数据更新异常，请重试";
          }
        })
        .catch((error) => {
          this.message = "网络异常，请重试";
          this.msg_show = !this.msg_show;
        });
    },


    //获取项目列表
    getProjectList:function(){
      fetch("/api/v1/project/list", {
        method: 'post',
        body: JSON.stringify({

        })
      })
        .then(result => {
          return result.json();//解析流
        })
        //.then(data => console.log(data))
        .then(data => {
          if (data.code == "200") {
            this.message = "项目数据获取成功";
            this.projectList = data.data;
            let options = this.search[0].options;
            for (let i=0;i<this.projectList.length;i++){
              let projectObj = {};
              projectObj.label = this.projectList[i].name;
              projectObj.value = this.projectList[i].id;
              options.push(projectObj);
            };
          } else {
            this.message = "数据更新异常，请重试";
          }
        })
        .catch((error) => {
          this.message = "网络异常，请重试";
          this.msg_show = !this.msg_show;
        });
    },

    //上一页
    prevPage() {
      console.log(this.currentPage);
      if (this.currentPage == 1) {
        return false;
      } else {
        this.currentPage--;
        this.getCurrentPageData();
      }
    },
    // 下一页
    nextPage() {
      if (this.currentPage == this.totalPage) {
        return false;
      } else {
        this.currentPage++;
        this.getCurrentPageData();
      }
    },
    //刷新页面
    leave: function () {
      if (this.refresh) {
        this.$router.push({path: '/monitoring/null'})
      }
    }
  },
  created() {
    this.InitLeftMenu();
  }
};
</script>

<style scoped>
.history {
  width: 100%;
  height: 100%;
}

.table_content {
  width: 100%;
  height: calc(100% - 100px);
  padding: 20px 0px;
}

.table_content > table {
  width: 100%;
  height: 100%;
  border: 1px solid #094b8e;
  background-color: #16518d;
}

.table_content > table tr th {
  background-color: #0e345b;
}

/* .table_content > table tr td {
  background-color: #16518d;
} */

.table_content > table tr td input {
  width: 16px;
  height: 16px;
}

.table_content > table tr:nth-child(2n) {
  background-color: #11406f;
}

.table_content > table tr {
  /*border-bottom: 1px solid #225892;*/
  height: 62px;
}

.table_content > table tr td,
.table_content > table tr th {
  text-align: center;
  color: #ffffff;
}

.table_paging {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid #105ba8;
  border-radius: 6px;
}

.table_paging > p {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: right;
  margin-bottom: 0;
  color: #c1c2c6;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
}

.table_paging > p > button {
  margin: 0 8px;
  width: 10px;
  height: 16px;
  border: none;
  outline: none;
}

.table_btn {
  color: #95bee5;
  background: transparent;
  border: 1px solid #95bee5;
  outline: transparent;
  padding: 5px 10px;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/2_environment/history.vue